import React, { FC } from "react";
import { useFormState } from "react-final-form";
import { IWizardStepContent } from "../../../../wizard/types";
import { IViewAcademicListItemHigher } from "../../../types";
import { ViewAcademic } from "../../components/ViewAcademic";

const Content: FC<IWizardStepContent> = ({ handleSubmit }) => {
  const {
    values: {
      injectedData: { data },
    },
  }: { values: { injectedData: { data: IViewAcademicListItemHigher } } } =
    useFormState(); // todo

  return (
    <form noValidate onSubmit={handleSubmit}>
      <ViewAcademic
        degreeName={data.degreeName}
        requiredDocuments={data.requiredDocs}
        applicationForms={data.applicationForms}
        applicationLink={data.applicationLink}
      />
    </form>
  );
};

export default Content;
